import FinishFillingVacancyModal from './FinishFillingVacancyModal.component';

export default FinishFillingVacancyModal;
